import { c as _c } from "react/compiler-runtime";
import LoadingButton from '@mui/lab/LoadingButton';
import { CircularProgress, type ButtonProps as MaterialButtonProps, type SxProps } from '@mui/material';
import { colors } from '../../styles/colors';
import { Typography } from '../typography';
export type ButtonProps = {
  text?: string;
  loading?: boolean;
} & MaterialButtonProps;
export const defaultButtonStyles: SxProps = {
  textTransform: 'none',
  border: `1px solid ${colors.border.default}`,
  height: '35px',
  borderRadius: '6px',
  '&& svg': {
    fontSize: '17px'
  },
  '&:hover': {
    color: colors.text.interactive.hover,
    border: colors.border.interactive.hover,
    background: colors.surface.interactive.hover
  }
};
export const Button: React.FC<ButtonProps> = t0 => {
  const $ = _c(15);
  let loading;
  let otherProps;
  let text;
  if ($[0] !== t0) {
    ({
      text,
      loading,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = loading;
    $[2] = otherProps;
    $[3] = text;
  } else {
    loading = $[1];
    otherProps = $[2];
    text = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      disabled: true,
      endIcon: <CircularProgress size={24} />
    };
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const loadingProps = t1;
  let t2;
  if ($[5] !== otherProps.sx) {
    t2 = {
      ...defaultButtonStyles,
      ...otherProps.sx
    };
    $[5] = otherProps.sx;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = loading && loadingProps;
  const t4 = text || "";
  const t5 = otherProps?.sx;
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <Typography.General.Subtitle text={t4} sx={t5} />;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== otherProps || $[11] !== t2 || $[12] !== t3 || $[13] !== t6) {
    t7 = <LoadingButton variant="outlined" {...otherProps} sx={t2} {...t3}>{t6}</LoadingButton>;
    $[10] = otherProps;
    $[11] = t2;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};